<!-- NEW PRICING -->
<section class="price-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col justify-content-center text-center">
        <h1 class="h1-2 text-primary mt-5" [innerHTML]="'LANDING.pricing.h1' | translate"></h1>
        <p class="text-gray large mb-4">{{ 'LANDING.pricing.subtext' | translate }}</p>

        <a class="cursor-pointer" routerLink="/signup" *ngIf="promoBannerActive">
          <div class="block-promo mb-4">
            <img class="promo-img cursor-pointer" src="https://firebasestorage.googleapis.com/v0/b/buk-pt.appspot.com/o/media%2Fimg-blackfriday-2.png?alt=media" alt="">
          </div>
        </a>

        <p class="color-green-2 large mb-5" *ngIf="ref">{{ 'LANDING.landing.refText3' | translate }} <span class="text-bold">{{ref.name}}</span>, <span class="text-lowercase">{{ 'LANDING.landing.refText2' | translate }}</span> 🎉</p>

        <div class="price-settings justify-content-center">
          <app-toggle label="{{ 'LANDING.pricing.payAnnual' | translate }}" [value]="showAnnual" (clicked)="toggleAnnual()">
            <span class="label discount">-20%</span>
          </app-toggle>
          <div class="ml-3">
            <app-toggle label="{{ 'LANDING.pricing.unlimitedSMS' | translate }} ⭐" [value]="withSMS" (clicked)="toggleSMS()"></app-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- 1 -->
      <div class="col-lg-4">
        <div class="price-box" data-nosnippet>
          <h3>{{ 'SHARED.plansModal.free' | translate }}</h3>
          <p class="desc">{{ 'LANDING.pricing.freeDescription' | translate }} 😉</p>
          <h4>0{{ getCurrencySymbol(selectedProPlanMonthly?.currency, 'wide') }}</h4>
          <p class="subtitle">{{ 'LANDING.pricing.features.one_provider' | translate }}</p>
          <ul class="price-list">
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.calendar' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.bookingPage' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.email100' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.marketingTools' | translate }}
            </li>
          </ul>

          <div class="pricebox-footer">
            <button (click)="analyticsEvent('pricing-free-signup')" rel="canonical" routerLink="/signup" class="btn btn-lg btn-primary w-100">
              {{ 'LANDING.pricing.registerBusiness' | translate }}
            </button>
            <!-- <p class="mt-2 desc text-center">{{ 'LANDING.landing.noCreditCardNeeded' | translate }}</p> -->
          </div>
        </div>
      </div>
      <!-- 2 -->
      <div class="col-lg-4">
        <div class="price-box box-selected" data-nosnippet>
          <span class="label-popular">{{ 'LANDING.pricing.morePopular' | translate }}</span>
          <h3>{{ 'SHARED.plansModal.professional' | translate }}</h3>
          <p class="desc" *ngIf="withSMS">{{ 'LANDING.pricing.proPlanDescription' | translate }} 🤩</p>
          <p class="desc" *ngIf="!withSMS">{{ 'LANDING.pricing.proPlanDescriptionNoSMS' | translate }} 🤩</p>

          <ng-container *ngIf="!showAnnual">
            <h4 class="mb-0" priceWithSpan [price]="getFlatPrice(selectedProPlanMonthly) / 100" [currency]="selectedProPlanMonthly?.currency"></h4>
            <p class="subtitle">+ {{(getPrice(selectedProPlanMonthly) / 100)}}{{getCurrencySymbol(selectedProPlanMonthly?.currency,
            'wide')}} {{ 'LANDING.pricing.byProvider' | translate}} {{ 'LANDING.pricing.perMonth' | translate}}</p>
          </ng-container>
          <ng-container *ngIf="showAnnual">
            <div class="d-flex">
              <h4 class="mb-0" priceWithSpan [price]="getFlatPrice(selectedProPlanAnnually) / 12 / 100"
              [currency]="selectedProPlanAnnually?.currency"></h4>
              <!-- <h4 class="ml-1 mb-0"><span class="old-price">{{getFlatPrice(selectedProPlanMonthly) / 100}}{{getCurrencySymbol(selectedProPlanMonthly?.currency,'wide')}}</span></h4> -->
            </div>
            <p class="subtitle mb-1">+ {{(getPrice(selectedProPlanAnnually) / 12 / 100)}}{{getCurrencySymbol(selectedProPlanAnnually?.currency, 'wide')}}
              <!-- <span class="old-price">{{getPrice(selectedProPlanMonthly) / 100}}{{getCurrencySymbol(selectedProPlanAnnually?.currency,'wide')}}</span> -->
              {{ 'LANDING.pricing.byProvider' | translate}} {{ 'LANDING.pricing.perMonth' | translate}}</p>
            <p class="subtitle text-gray">{{ 'LANDING.pricing.payed_yearly' | translate}}</p>
          </ng-container>

          <ul class="price-list">
            <li class="text-bold">
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.everythingFromFree' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.advancedCalendar' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.advancedBookingPage' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ (withSMS ? 'LANDING.pricing.features.smsEmailUnlimited' : 'LANDING.pricing.features.email') | translate }} ⭐
            </li>
            <ng-container *ngIf="showFeaturesPro">
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.personalizedReminders' | translate }}
              </li>
              <li *ngIf="withSMS">
                <i class="material-icons icon">check</i>
                <span class="var"> {{ 'LANDING.pricing.features.birthday' | translate }} ⭐ </span>
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.googleCalendar' | translate }}
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.stats' | translate }}
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.marketingCredit' | translate }}
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.whatsapp' | translate }}
              </li>
            </ng-container>
            <p class="expand text-center text-secondary mt-2" *ngIf="!showFeaturesPro"
            (click)="showFeaturesPro = true">{{ 'LANDING.pricing.features.viewMore' | translate }} <i class="material-icons ml-1">expand_more</i></p>
            <p class="expand text-center text-secondary mt-2" *ngIf="showFeaturesPro"
            (click)="showFeaturesPro = false">{{ 'LANDING.pricing.features.viewLess' | translate }} <i class="material-icons ml-1">expand_less</i></p>
          </ul>

          <div class="pricebox-footer">
            <button (click)="analyticsEvent('pricing-pro-signup')" rel="canonical" routerLink="/signup" class="btn btn-lg btn-primary w-100">
              {{ 'LANDING.pricing.registerBusiness' | translate }}
            </button>
            <p *ifCountry="'es'" class="mt-2 text-secondary text-center mb-0">{{ 'LANDING.pricing.tryPro' | translate }}</p>
          </div>
        </div>
      </div>
      <!-- 3 -->
      <div class="col-lg-4">
        <div class="price-box" data-nosnippet>
          <h3>{{ 'SHARED.plansModal.professional' | translate }}+</h3>
          <p class="desc">{{ 'LANDING.pricing.proPlusDescription' | translate }} 🚀</p>

          <ng-container *ngIf="!showAnnual">
            <h4 class="mb-0" priceWithSpan [price]="getFlatPrice(selectedProPlusPlanMonthly) / 100"
                [currency]="selectedProPlusPlanMonthly?.currency"></h4>
            <p class="subtitle mb-0">+ {{(getPrice(selectedProPlusPlanMonthly) / 100)}}{{getCurrencySymbol(selectedProPlusPlanMonthly?.currency,'wide')}} {{ 'LANDING.pricing.byProvider' | translate}} {{ 'LANDING.pricing.perMonth' | translate}}</p>
          </ng-container>

          <ng-container *ngIf="showAnnual">
            <div class="d-flex">
              <h4 class="mb-0" priceWithSpan [price]="getFlatPrice(selectedProPlusPlanAnnually) / 12 / 100"
                [currency]="selectedProPlusPlanAnnually?.currency"></h4>
              <h4 class="ml-1 mb-0">
                <!-- <span class="old-price">{{getFlatPrice(selectedProPlusPlanMonthly) /
                  100}}{{getCurrencySymbol(selectedProPlusPlanMonthly?.currency,'wide')}}</span> -->
                </h4>
            </div>
            <p class="subtitle mb-1">+ {{(getPrice(selectedProPlusPlanAnnually) / 12 /
              100)}}{{getCurrencySymbol(selectedProPlusPlanAnnually?.currency, 'wide')}}
              <!-- <span class="old-price">{{getPrice(selectedProPlusPlanMonthly) /
                100}}{{getCurrencySymbol(selectedProPlusPlanAnnually?.currency,'wide')}}</span>  -->
                {{ 'LANDING.pricing.byProvider' |
              translate}} {{ 'LANDING.pricing.perMonth' | translate}}</p>
            <p class="subtitle text-gray">{{ 'LANDING.pricing.payed_yearly' | translate}}</p>
          </ng-container>

          <ul class="price-list">
            <li class="text-bold">
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.all_pro' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.googleReserve' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.googleReviews' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.marketingCredit2' | translate }}
            </li>
            <li>
              <i class="material-icons icon">check</i>
              {{ 'LANDING.pricing.features.loyalty' | translate }}
            </li>
            <ng-container *ngIf="showFeaturesProPlus">
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.websiteIntegration' | translate }}
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.personalizedEmails' | translate }}
              </li>
              <li>
                <i class="material-icons icon">check</i>
                {{ 'LANDING.pricing.features.apiAccess' | translate }}
              </li>
            </ng-container>
            <p class="expand text-center text-secondary mt-2" *ngIf="!showFeaturesProPlus"
            (click)="showFeaturesProPlus = true">{{ 'LANDING.pricing.features.viewMore' | translate }} <i class="material-icons ml-1">expand_more</i></p>
            <p class="expand text-center text-secondary mt-2" *ngIf="showFeaturesProPlus"
            (click)="showFeaturesProPlus = false">{{ 'LANDING.pricing.features.viewLess' | translate }} <i class="material-icons ml-1">expand_less</i></p>
          </ul>

          <div class="pricebox-footer">
            <button (click)="analyticsEvent('pricing-pro-plus-signup')" rel="canonical" routerLink="/signup" class="btn btn-lg btn-primary w-100">
              {{ 'LANDING.pricing.registerBusiness' | translate }}
            </button>
            <!-- <p class="mt-2 desc text-center">{{ 'LANDING.pricing.withoutCommitment' | translate }}</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="price-box box-custom height-auto" data-nosnippet>
          <div class="row align-items-center">
            <div class="col-md-8 mt-3 mb-3">
              <h3 class="d-flex align-items-center">{{ 'LANDING.pricing.enterprise' | translate }} <span class="label-enterprise ml-2">{{ 'LANDING.pricing.enterpriseLabel' | translate }}</span></h3>
              <p class="desc mb-0">{{ 'LANDING.pricing.enterpriseDesc' | translate }}</p>
            </div>
            <div class="col-md-4 mt-3 mb-3">
              <a
              (click)="analyticsEvent('pricing-proplus-demo')"
              class="btn btn-lg btn-primary w-100"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ 'LANDING.pricing.features.contact' | translate }}</a
            >
            <p class="mt-2 desc text-center mb-0">{{ 'LANDING.pricing.withoutCommitment' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center text-center">
      <div class="col-lg-4 col-md-4">
        <p class="text-gray mb-3">{{ 'LANDING.pricing.vatDisclaimer' | translate }}</p>
        <img style="width: 80%" url="pay-methods.png" responsiveImg mobileWidth="400" desktopWidth="820" alt="" />
      </div>
    </div>
  </div>
</section>
